export class Singleflight {
  constructor() {
    this.lockMap = {}; // 是否锁定
    this.cbQueue = {}; // 回调队列
  }
  /**
   * 返回全局单例
   */
  static getInstance() {
    if (!Singleflight.instance) {
      Singleflight.instance = new Singleflight();
    }
    return Singleflight.instance;
  }
  /**
   * @description 执行任务，任务在锁定期间只会执行一次，每个回调都是使用第一次执行的结果
   * @param {Function} taskBuilder 任务构造函数，返回 Promise
   */
  do(key, taskBuilder) {
    return new Promise((resolve, reject) => {
      const cbQueue = this.cbQueue;
      if (!cbQueue[key]) {
        cbQueue[key] = [];
      }
      cbQueue[key].push([resolve, reject]);
      const lockMap = this.lockMap;
      if (!lockMap[key]) {
        lockMap[key] = true;
        const p = taskBuilder(key);
        p &&
          p.then &&
          p.then(
            this._resolveTask.bind(this, key),
            this._rejectTask.bind(this, key),
          );
      }
    });
  }
  /**
   * 成功回调
   * @param {*} res
   */
  _resolveTask(key, res) {
    const cbQueue = this.cbQueue;
    const queue = cbQueue[key] || [];
    for (const task of queue) {
      task[0](res);
    }
    delete cbQueue[key];
    delete this.lockMap[key];
  }
  /**
   * 失败回调
   * @param {*} err
   */
  _rejectTask(key, err) {
    const cbQueue = this.cbQueue;
    const queue = cbQueue[key] || [];
    for (const task of queue) {
      task[1](err);
    }
    delete cbQueue[key];
    delete this.lockMap[key];
  }
}
Singleflight.instance = null;

/**
 * 智能丢帧决策器。
 * 使用累积误差算法来决定是否保留当前帧，并强制保留关键帧。
 */
export class SmartFrameDropper {
  constructor(srcFps, dstFps) {
    this.srcFps = srcFps;
    this.dstFps = dstFps;
    // 累积误差，用于决定是保留还是丢弃帧，初始为目标帧率的一半
    this.error = 0.5;
    this.frameToEncodeCount = 0;
    this.frameToSkipCount = 0;
  }

  /**
   * 决定当前帧是否应该被保留和编码。
   * @param {boolean} isKeyFrame - 如果为 true，表示当前帧是关键帧（I帧）。
   * @returns {boolean} 如果为 true，则应该编码此帧；否则丢弃。
   */
  shouldEncodeFrame(isKeyFrame) {
    // 规则 1: 关键帧必须始终被保留，无条件返回 true
    if (isKeyFrame) {
      this.frameToEncodeCount++;
      // 关键帧被强制保留，我们需要重置误差以避免后续连续丢帧过多
      this.error = 0.5;
      return true;
    }

    // 规则 2: 对于非关键帧，使用累积误差算法决定保留或丢弃
    this.error += this.dstFps;

    // 如果误差大于或等于源帧率，说明是时候保留一帧了
    if (this.error >= this.srcFps) {
      this.error -= this.srcFps; // 减少误差
      this.frameToEncodeCount++;
      return true;
    } else {
      // 误差不足，丢弃这一帧
      this.frameToSkipCount++;
      return false;
    }
  }

  // 可选：打印统计信息
  getStats() {
    console.log(
      `总共编码了 ${this.frameToEncodeCount} 帧，跳过了 ${this.frameToSkipCount} 帧。`,
    );
  }
}
